export default {
  'paymentConditions.domain.name': 'Name',
  'paymentConditions.domain.percentage': 'Disc./Acres.(%)',
  'paymentConditions.domain.installments': 'Installments',
  'paymentConditions.domain.installments.add': 'Add Installment',
  'paymentConditions.domain.installments.intervalDays': 'Interval of Days',
  'paymentConditions.domain.installments.percentage': 'Percentage',

  'paymentConditions.form.installments.rules.minimum': 'At least 1 installment',
  'paymentConditions.form.installments.rules.mustBe100':
    'The sum of the percentages must be 100.',

  'paymentConditions.create': 'Create Payment Condition',
  'paymentConditions.create.notification.success': 'Success',
  'paymentConditions.create.notification.successDescription':
    'Payment Condition created.',

  'paymentConditions.update': 'Update Payment Condition',
  'paymentConditions.update.notification.success': 'Success',
  'paymentConditions.update.notification.successDescription':
    'Payment Condition updated.',

  'paymentConditions.remove': 'Remove Payment Condition',
  'paymentConditions.remove.alert':
    'Do you really want to remove the payment condition:',
  'paymentConditions.remove.notification.success': 'Success',
  'paymentConditions.remove.notification.successDescription':
    'Payment Condition removed.',

  'paymentConditions.generateReport': 'Generate Report',
  'paymentConditions.status.message.success':
    'Status of payment terms successfully changed!',
};
